import { render, staticRenderFns } from "./mouldManage.vue?vue&type=template&id=1aeb2894&scoped=true"
import script from "./mouldManage.vue?vue&type=script&lang=js"
export * from "./mouldManage.vue?vue&type=script&lang=js"
import style0 from "./mouldManage.vue?vue&type=style&index=0&id=1aeb2894&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb2894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aeb2894')) {
      api.createRecord('1aeb2894', component.options)
    } else {
      api.reload('1aeb2894', component.options)
    }
    module.hot.accept("./mouldManage.vue?vue&type=template&id=1aeb2894&scoped=true", function () {
      api.rerender('1aeb2894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/mouldManage.vue"
export default component.exports